import { render, staticRenderFns } from "./HouseDetail.vue?vue&type=template&id=8d208ce4&scoped=true"
import script from "./HouseDetail.vue?vue&type=script&lang=js"
export * from "./HouseDetail.vue?vue&type=script&lang=js"
import style0 from "./HouseDetail.vue?vue&type=style&index=0&id=8d208ce4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d208ce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d208ce4')) {
      api.createRecord('8d208ce4', component.options)
    } else {
      api.reload('8d208ce4', component.options)
    }
    module.hot.accept("./HouseDetail.vue?vue&type=template&id=8d208ce4&scoped=true", function () {
      api.rerender('8d208ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/houseOrder/HouseDetail.vue"
export default component.exports